import React, { useEffect, useMemo, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { EQueryParams, ESpecialOfferInternalViewModel } from 'utils/enums';
import { useUrlQuery } from 'utils/index';
import { OfferData } from 'utils/types';
import { SpecialOffer } from './SpecialOffer';
import { useStoreState } from 'state/hooks/store.state.hook';
import { Carousel } from 'components/Carousel/Carousel';
import { CarouselItem } from 'components/Carousel/CarouselItem';

const CAROUSEL_LIMIT = 99;

export interface ISpecialOffersWrapperProps {
  selectOffer: (offerData: OfferData) => void;
  specialOffers?: any; //todo
  tooltipOpenEventHandler?: () => void;
  refetchOffers: () => void;
}

export const SpecialOffersWrapper: React.FC<ISpecialOffersWrapperProps> = ({
  selectOffer,
  specialOffers,
  tooltipOpenEventHandler,
  refetchOffers,
}) => {
  const { storeTheme } = useStoreState();

  const campaignOfferId = useUrlQuery(EQueryParams.OFFER_ID);
  const [specialOffersList, setSpecialOffersList] = useState<any>([]);

  useEffect(() => {
    if (!specialOffers || campaignOfferId) return;

    setSpecialOffersList(specialOffers);
  }, [specialOffers]);

  const isCarouselView = useMemo(
    () =>
      storeTheme?.general?.specialOffersInternalViewModel !==
        ESpecialOfferInternalViewModel.PLAY_SIMPLE &&
      (!isMobileOnly ||
        storeTheme?.general?.specialOffersInternalViewModel !==
          ESpecialOfferInternalViewModel.POKER_FACE),
    [storeTheme?.general?.specialOffersInternalViewModel],
  );

  return (
    <>
      {specialOffersList?.length > 0 &&
        (isCarouselView ? (
          <Carousel
            bundleViewModel={
              storeTheme?.general?.specialOffersInternalViewModel
            }
          >
            {specialOffersList
              .slice(0, CAROUSEL_LIMIT)
              .map((offer: OfferData, i: number) => (
                <CarouselItem key={i} data={offer}>
                  <SpecialOffer
                    data={offer}
                    selectOffer={() => selectOffer(offer)}
                    tooltipOpenEventHandler={tooltipOpenEventHandler}
                    refetchOffers={refetchOffers}
                  />
                </CarouselItem>
              ))}
          </Carousel>
        ) : (
          <div className="offers-wrapper--column-view">
            {specialOffersList.map((offer: OfferData, i: number) => (
              <SpecialOffer
                data={offer}
                selectOffer={() => selectOffer(offer)}
                key={i}
                tooltipOpenEventHandler={tooltipOpenEventHandler}
                refetchOffers={refetchOffers}
              />
            ))}
          </div>
        ))}
    </>
  );
};
